<template>
  <div v-if="dialogVisible">
    <el-dialog
      title="合同发起记录查询"
      :visible.sync="dialogVisible"
      width="1160px"
      :center="true"
      :show-close="true"
    >
      <hr style="margin-bottom: 9px" />
      <el-form
        :model="param"
        :inline="true"
        label-width="125px"
        class="formInline"
        size="mini"
      >
        <div class="slide-wrap" ref="slideWrap1">
          <el-form-item label="姓名">
            <el-input
              v-model="param.employeeName"
              placeholder="请输入姓名..."
              :maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input
              v-model="param.idCard"
              placeholder="请输入身份证号..."
              :maxlength="18"
            ></el-input>
          </el-form-item>
          <el-form-item label="项目客户">
            <el-select
              clearable
              v-model="param.clientId"
              filterable
              placeholder="请选择..."
            >
              <el-option
                :label="item"
                :value="item"
                v-for="(item, index) in allCustomers"
                :key="index"
              ></el-option>
            </el-select>
            <!-- <el-button type="text" class="reset-btn" @click="resetForm()">清空</el-button> -->
            <el-button class="search-btn" @click="submitForm()">筛选</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="tableBody">
        <el-table
          class="limitManagerTable table-expand"
          style="width: 100%"
          :data="tableData"
          size="small"
          border
          v-loading="listLoading"
          element-loading-text="拼命加载中..."
          header-row-class-name="table-header"
        >
          <el-table-column
            fixed="left"
            width="50"
            type="index"
            label="#"
            align="center"
          ></el-table-column>
          <el-table-column
            width="100"
            prop="employeeName"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            width="150"
            prop="documentNumber"
            label="身份证号"
            align="center"
          ></el-table-column>
          <el-table-column
            width="120"
            prop="clientId"
            label="项目客户"
            align="center"
          ></el-table-column>
          <el-table-column
            width="190"
            prop="qiyuesuoAccount"
            label="所属公司"
            align="center"
          ></el-table-column>
          <el-table-column
            width="190"
            prop="syncTime"
            label="发起时间"
            align="center"
          ></el-table-column>
          <el-table-column
            width="120"
            prop="start"
            label="合同开始日期"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ computedDate(scope.row.start) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            width="120"
            prop="endDate"
            label="合同结束日期"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ computedDate(scope.row.endDate) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="isSign"
            label="是否签约"
            align="center"
          ></el-table-column>
          <el-table-column
            width="190"
            prop="signTime"
            label="签约时间"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.signTime">
                {{ scope.row.signTime }}
              </span>
              <span v-else-if="!scope.row.signTime"> -- </span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          class="pagination table-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="param.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="param.pageSize"
          layout="slot,sizes, total,  prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- <span slot="footer" class="dialog-footer"> </span> -->
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      dialogVisible: false,
      param: {
        salemansName: "",
        idCard: "",
        clientID: "",
        pageNo: 1,
        pageSize: 10,
      },
      allCustomers: [], //项目列表数组
      tableData: [],
      total: 0,
      listLoading: true,
    };
  },
  mounted() {
    this.getTerminal();
    this.getList();
  },
  methods: {
    //获取项目列表
    getTerminal() {
      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/clientDropDownList",
      })
        .then((res) => {
          this.allCustomers = res.data.data;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    getList() {
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmQhrInfoRest/getContractList",
        headers: { "content-type": "application/json" },
        params: {
          salemansName: this.param.employeeName,
          clientID: this.param.clientId,
          idCard: this.param.idCard,
          pageNo: this.param.pageNo,
          pageSize: this.param.pageSize,
        },
      }).then((res) => {
        console.log(res.data);
        this.tableData = res.data;
        this.listLoading = false;
      });
      this.$http({
        method: "POST",
        url: "/rest/CrmQhrInfoRest/countContract",
        params: {
          salemansName: this.param.employeeName,
          clientID: this.param.clientId,
          idCard: this.param.idCard,
          pageNo: this.param.pageNo,
          pageSize: this.param.pageSize,
        },
      }).then((res) => {
        this.total = res.data;
      });
    },
    handleSizeChange(value) {
      this.param.pageSize = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.param.pageNo = value;
      // this.Information = false;
      this.getList();
    },
    submitForm() {
      this.param.pageNo = 1;
      this.getList();
    },
    computedDate(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD");
      } else {
        return "";
      }
    }
  },
};
</script>

<style scoped>
/deep/ .el-dialog--center .el-dialog__body {
  padding: 8px 5px 8px;
}
.search-btn {
  margin: 0 16px;
}
.tableBody {
  background-color: white;
  margin-top: 15px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/contractQys.vue